<template>
  <div class="history-monitor-page" v-loading="loading">
    <el-alert
      v-if="error"
      :title="error"
      type="warning"
      :closable="false"
      show-icon
      class="page-alert"
    />

    <AnalysisDataStatusPanel
      :payload="payload"
      :loading="loading"
      title="分析与行情数据健康"
      subtitle="这个页面只回答“系统现在能不能分析”。内部数据维护与运行细节由后台治理，不作为日常操作界面。"
      :show-items="true"
      :show-name="true"
      @refresh="refreshData"
    />

    <el-row :gutter="14" class="info-row">
      <el-col :span="8">
        <el-card shadow="never" class="info-card">
          <div class="info-icon"><i class="el-icon-data-line"></i></div>
          <strong>长期分析数据</strong>
          <p>股票日线按分析策略窗口保留，核心指数日线保留长期窗口。周线、月线由日线和官方交易日历自动生成。</p>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="never" class="info-card">
          <div class="info-icon"><i class="el-icon-s-grid"></i></div>
          <strong>盘中技术数据</strong>
          <p>5分钟是分钟级基础数据。15分钟、60分钟由5分钟数据自动生成，不再单独维护另一套历史数据。</p>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card shadow="never" class="info-card">
          <div class="info-icon"><i class="el-icon-refresh"></i></div>
          <strong>缺口与降级</strong>
          <p>数据源异常时优先使用可用缓存并标记降级；没有可用缓存才显示暂不可完整分析，不把未知状态伪装成正常。</p>
        </el-card>
      </el-col>
    </el-row>

    <el-card shadow="never" class="boundary-card">
      <div slot="header" class="boundary-title">页面边界</div>
      <div class="boundary-grid">
        <span><i class="el-icon-circle-check"></i> 页面只读，不执行数据维护</span>
        <span><i class="el-icon-circle-check"></i> 不修改业务数据或缓存</span>
        <span><i class="el-icon-circle-check"></i> 后台任务由受控运行链负责</span>
        <span><i class="el-icon-circle-check"></i> 不把缓存完整度等同分析可用性</span>
        <span><i class="el-icon-circle-check"></i> 当前形成中的交易日不算缺口</span>
        <span><i class="el-icon-circle-check"></i> 异常状态不会伪装成正常</span>
      </div>
    </el-card>
  </div>
</template>

<script>
import AnalysisDataStatusPanel from '@/components/AnalysisDataStatusPanel.vue'
import { historyMonitorApi } from '@/api/historyMonitor'
import { ANALYSIS_DATA_PROJECTION, validateAnalysisDataProjection } from '@/utils/analysisDataStatus'

export default {
  name: 'HistoryMonitor',
  components: { AnalysisDataStatusPanel },
  data() {
    return {
      loading: false,
      error: '',
      payload: {}
    }
  },
  mounted() { this.refreshData() },
  methods: {
    async refreshData() {
      this.loading = true
      this.error = ''
      try {
        const response = await historyMonitorApi.getSummary({
          params: { projection: ANALYSIS_DATA_PROJECTION, _: Date.now() },
          headers: { 'Cache-Control': 'no-cache' },
          timeout: 15000,
          monitorSilent: true
        })
        this.payload = validateAnalysisDataProjection(response, 'history_monitor')
      } catch (error) {
        this.payload = {}
        this.error = `分析数据状态暂不可确认：${(error && error.message) || '未知错误'}`
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.history-monitor-page { max-width: 1480px; margin: 0 auto; }
.page-alert { margin-bottom: 14px; }
.info-row { margin-top: 16px; }
.info-row > .el-col { display: flex; }
.info-card { width: 100%; border-radius: 16px; border-color: #dfe7f2; }
.info-icon { width: 38px; height: 38px; display: flex; align-items: center; justify-content: center; border-radius: 12px; background: #eef5ff; color: #2563eb; font-size: 19px; }
.info-card strong { display: block; margin-top: 10px; color: #0f172a; }
.info-card p { margin: 7px 0 0; color: #64748b; font-size: 12px; line-height: 1.65; }
.boundary-card { margin-top: 16px; border-radius: 16px; border-color: #dfe7f2; }
.boundary-title { font-size: 15px; font-weight: 700; color: #1f2937; }
.boundary-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 10px 16px; color: #526071; font-size: 12px; }
.boundary-grid i { margin-right: 6px; color: #16a34a; }
@media (max-width: 1100px) {
  .info-row > .el-col { width: 100%; margin-bottom: 12px; }
  .boundary-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
</style>